const resolveValue = (value, ...args) =>
  typeof value === 'function' ? value(...args) : value;

const getItemLayout =
  ({
    getItemHeight,
    getItemSeparatorHeight = 0,
    getSectionHeaderHeight = 0,
    getSectionFooterHeight = 0,
    getSectionSeparatorHeight = 0,
    getListHeaderHeight = 0,
  }) =>
  (data, index) => {
    if (!data || !data.length) {
      return {length: 0, offset: 0, index};
    }

    let offset = resolveValue(getListHeaderHeight);
    let globalIndex = 0;

    for (let sectionIndex = 0; sectionIndex < data.length; sectionIndex++) {
      const currentSectionHeaderHeight = resolveValue(
        getSectionHeaderHeight,
        sectionIndex,
      );
      const currentSectionFooterHeight = resolveValue(
        getSectionFooterHeight,
        sectionIndex,
      );
      const currentSectionSeparatorHeight = resolveValue(
        getSectionSeparatorHeight,
        sectionIndex,
      );

      if (index === globalIndex) {
        return {length: currentSectionHeaderHeight, offset, index};
      }
      offset += currentSectionHeaderHeight;
      globalIndex++;

      offset += currentSectionSeparatorHeight;

      for (
        let itemIndex = 0;
        itemIndex < data[sectionIndex].data.length;
        itemIndex++
      ) {
        const currentItemHeight = resolveValue(
          getItemHeight,
          data[sectionIndex].data[itemIndex],
          sectionIndex,
          itemIndex,
        );

        if (index === globalIndex) {
          return {length: currentItemHeight, offset, index};
        }

        offset += currentItemHeight;
        globalIndex++;

        if (itemIndex < data[sectionIndex].data.length - 1) {
          offset += resolveValue(
            getItemSeparatorHeight,
            sectionIndex,
            itemIndex,
          );
        }
      }

      offset += currentSectionSeparatorHeight;

      if (index === globalIndex) {
        return {length: currentSectionFooterHeight, offset, index};
      }
      offset += currentSectionFooterHeight;
      globalIndex++;
    }

    return {length: 0, offset: 0, index};
  };

export default getItemLayout;
